export type RuntimeTranslateVars = Record<string, string | number>;

let runtimeTranslations: Record<string, string> = {};

export function setRuntimeTranslations(translations: Record<string, string>): void {
  runtimeTranslations = translations;
}

export function translateRuntime(
  key: string,
  fallback: string,
  vars: RuntimeTranslateVars = {},
): string {
  const template = runtimeTranslations[key] ?? fallback;
  return Object.entries(vars).reduce(
    (result, [name, value]) => result.replace(new RegExp(`\\{\\{${name}\\}\\}|\\{${name}\\}`, 'g'), String(value)),
    template,
  );
}
